/**
 * Shared helpers for VCN (virtual card number) and expiration display.
 * Used by Payment Assignment Payment Detail modal and can be reused by
 * Application Engine, VirtualCard component, etc.
 */

const MIN_PAN_LENGTH = 12

/**
 * Masks a card number for display (e.g. "4147 **** **** 6666").
 * Returns the input unchanged if too short to mask.
 */
export function maskCardNumber(pan: string): string {
  if (!pan || pan.length < MIN_PAN_LENGTH) return pan
  return `${pan.slice(0, 4)} **** **** ${pan.slice(pan.length - 4)}`
}

/**
 * Formats a PAN with spaces for display (e.g. "4147 1234 5678 6666").
 * Returns the input unchanged if too short to format.
 */
export function formatPanDisplay(pan: string): string {
  if (!pan || pan.length < MIN_PAN_LENGTH) return pan
  return `${pan.slice(0, 4)} ${pan.slice(4, 8)} ${pan.slice(8, 12)} ${pan.slice(12)}`
}

/**
 * Formats an ISO expiration time (e.g. "2030-12-31T23:59:59Z") as MM/YYYY.
 * Returns fallback when input is missing or unparseable.
 */
export function formatVcnExpiration(
  expirationTime: string | undefined,
  fallback = '—'
): string {
  if (!expirationTime) return fallback
  const dateStr = expirationTime.split('T')[0]
  const [year, month] = dateStr?.split('-') ?? []
  if (!year || !month) return fallback
  return `${month}/${year}`
}
